import {getImageAssetUrl} from '@/_application/core/utils/common';
import {Routes} from '@/config/routes';

export interface Icons {
    key: string;
    title: string;
    image: string;
    url: string;
    size: number;
}

export const shortcuts: Icons[] = [
    {
        key: 'sieu_deal',
        title: 'Siêu deal mỗi ngày',
        image: getImageAssetUrl('icons/blue-fire.png'),
        url: Routes.hotPromotions,
        size: 30,
    },
    {
        key: 'voucher_giam_gia',
        title: 'Voucher giảm giá',
        image: getImageAssetUrl('icons/voucher.png'),
        url: Routes.hotPromotions,
        size: 36,
    },
    {
        key: 'uu_dai',
        title: 'Ưu đãi hấp dẫn',
        image: getImageAssetUrl('icons/active-gift.png'),
        url: Routes.hotPromotions,
        size: 36,
    },
    {
        key: 'tra_cuu_don_hang',
        title: 'Tra cứu đơn hàng',
        image: getImageAssetUrl('icons/order-box.png'),
        url: `${Routes.customer}/orders`,
        size: 36,
    },
    {
        key: 'sieu_thi_gan_ban',
        title: 'Siêu thị gần bạn',
        image: getImageAssetUrl('icons/kid-location.png'),
        url: Routes.storeSystem,
        size: 30,
    },
    {
        key: 'mien_phi_giao_hang',
        title: 'Miễn phí giao hàng',
        image: getImageAssetUrl('icons/free-ship.png'),
        url: Routes.deliveryMethod,
        size: 36,
    },
    {
        key: 'doi_tra_15_ngay',
        title: 'Đổi trả 15 ngày',
        image: getImageAssetUrl('icons/circle-45.png'),
        url: Routes.returnRegulations,
        size: 36,
    },
    {
        key: 'tich_luy_kicoin',
        title: 'Tích luỹ Kicoin',
        image: getImageAssetUrl('icons/icon-kicoin.png'),
        url: Routes.memberIncentives,
        size: 36,
    },
    {
        key: 'hoi_dap',
        title: 'Hỏi đáp ngay',
        image: getImageAssetUrl('icons/question.png'),
        url: Routes.questionAndAnswer,
        size: 36,
    },
];

export const mobileShortcuts: Icons[] = [
    {
        key: 'danh_muc',
        title: 'Danh mục',
        image: getImageAssetUrl('icons/active-category.png'),
        url: '',
        size: 36,
    },
    ...shortcuts,
];
